import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ClientsToCallComponent } from './pages/clients-to-call/clients-to-call.component';
import { MatterDetailComponent } from './pages/matters/matter-detail/matter-detail.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SurveyDetailComponent } from './pages/survey-detail/survey-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'matters',
    canActivate: [MsalGuard, AuthGuard],
    children: [
      {
        path: '',
        component: ClientsToCallComponent,
        canActivate: [MsalGuard, AuthGuard],
      },
      {
        path: 'details/:matterId/:surveyTypeId/:month/:year',
        component: MatterDetailComponent,
        canActivate: [MsalGuard, AuthGuard],
      },
    ],
  },
  {
    path: 'surveys',
    canActivate: [MsalGuard, AuthGuard],
    children: [
      {
        path: '',
        component: ClientsToCallComponent,
        canActivate: [MsalGuard, AuthGuard],
      },
      {
        path: 'details/:surveyId/:matterNumber/:month/:year',
        component: SurveyDetailComponent,
        canActivate: [MsalGuard, AuthGuard],
      },
    ],
  },
  {
    path: 'clients-to-call',
    component: ClientsToCallComponent,
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [MsalGuard, AdminGuard],
  },
  {
    // Needed for handling redirect after login
    path: 'auth',
    component: MsalRedirectComponent,
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '**', component: NotFoundComponent }, // Wildcard route for 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
